import { getProfit, getTaxes, getFees } from './sale-func'
import { formatDate } from '@/utils/helpers'

export const createSalesCSV = (sales) => {
  const headers = [
    'Date',
    'ID',
    'PO Number',
    'Item Number',
    'ASIN',
    'Amazon SKU',
    'Sale',
    'Cost',
    'Ebay/Amazon Fee',
    'Shipping',
    'Profit',
    'Tax',
    'Amazon Order Id',
    'Amazon Buyer Account',
    'Buyer Name',
    'Buyer Id',
    'Vendor',
    'Quantity',
    'Notes',
    'Tracking Number',
    'Account',
    'Invoice Checked',
    'Confirmed Billed',
    'Submitted By'
  ]

  const rows = sales.map(sale => [
    formatDate(sale.CreatedDate),
    sale.ID,
    sale.PONumber,
    sale.itemnumber,
    sale.listingid || '',
    sale.SKU || '',
    (parseFloat(sale.ebayprice) || 0).toFixed(2),
    (parseFloat(sale.ActualMyCost) || 0).toFixed(2),
    getFees(sale),
    (parseFloat(sale.ActualShipping) || 0).toFixed(2),
    getProfit(sale),
    getTaxes(sale),
    sale.Vendor == 'Amazon' ? sale.invoice_id : '',
    sale.Vendor == 'Amazon' ? sale.order_item_code : '',
    sale.shippingname || '',
    sale.BuyerID || '',
    sale.Vendor || '',
    sale.quantity || 1,
    sale.Note || '',
    sale.trackingnumber || '',
    sale.vendorAccount || '',
    sale.InvoiceChecked ? 'Yes' : 'No',
    sale.ConfirmedBilled ? 'Yes' : 'No',
    sale.submitted_by || '',
    sale.Deleted ? 'Deleted' : ''
  ])

  return [headers, ...rows]
    .map(row => row.map(field => `"${field}"`).join(','))
    .join('\n')
} 